export enum DestinationType {
    SMS = "SMS",
    Email = "Email",
    Push = "Push",
    TwilioMessage = "TwilioMessage"
};